import React, {Component} from 'react';
import Modal from 'react-bootstrap/Modal';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
  checkAccountEngagement,
  closeTour,
  startTour,
  stopTour,
  openTourMultiTime,
} from './reducer';
import './index.css';
import {withRouter} from 'react-router-dom';
import tutorials from '../../utils/config/tutorials';
import VideoPlayer from '../videoplayer';
import {Trans} from 'react-i18next';
import {showTourHint} from '../layout/header/reducer';
import subscriptionUtils from '../../utils/subscriptionUtils';
import i18n from 'i18next';
import gtmUtils from '../../utils/gtmUtils';
import {extendMenu} from '../layout/sidebar/reducer';

@withRouter
@connect(
  state => ({
    isOpened: state.components.tutorial.isOpened,
    status: state.components.tutorial.status,
    tutorialMode: state.components.tutorial.tutorialMode,
    isFirstTime: state.components.tutorial.isFirstTime,
    auth: state.components.auth.accountSummary,
    isUpgrade: state.components.auth.accountSummary.customer.upgraded,
    functionType: state.components.auth.accountSummary.customer.functionType,
    extendMenuOn: state.components.layout.sidebar.extendMenuOn,
  }),
  dispatch =>
    bindActionCreators(
      {
        checkAccountEngagement,
        closeTour,
        startTour,
        stopTour,
        showTourHint,
        openTourMultiTime,
        extendMenu,
      },
      dispatch
    )
)
export default class Tutorial extends Component {
  componentDidMount() {
    const {auth, checkAccountEngagement, functionType} = this.props;
    const noSubscription = subscriptionUtils.noSubscription(auth);
    if (noSubscription) return;
    checkAccountEngagement(functionType, auth);
  }

  handleTaskClick = path => {
    const {startTour, closeTour, history} = this.props;
    history.push(path);
    closeTour();
    startTour();
  };

  handleTourOpen = () => {
    const {stopTour, extendMenu, extendMenuOn} = this.props;
    if (!extendMenuOn) {
      extendMenu();
    }
    stopTour();
  };

  handleTourClose = () => {
    const {
      closeTour,
      isFirstTime,
      showTourHint,
      openTourMultiTime,
    } = this.props;
    closeTour();
    /* TODO: put 'isFirstTime' state in cookie */
    if (isFirstTime) {
      showTourHint();
      openTourMultiTime();
    }
  };

  getTaskStepCount = count => (
    <Trans i18nKey="c.tutorial.task.steps" count={count}>
      {{count}} steps
    </Trans>
  );

  render() {
    const {
      isOpened,
      closeTour,
      isUpgrade,
      functionType,
      status: {
        addSkuLookTourViewed,
        productGroupTourViewed,
        moduleConfigurationTourViewed,
        apiIntegrationTourViewed,
        analyticsTourViewed,
        addEyewearFrameTourViewed,
        productEyewearTourViewed,
        lensTintEyewearTourViewed,
        moduleConfigurationTourEyewearViewed,
        apiIntegrationTourEyewearViewed,
        analyticsTourEyewearViewed,
      },
      extendMenu,
      extendMenuOn,
    } = this.props;

    const totalTasks = functionType === 'EYEWEAR' ? 6 : isUpgrade ? 5 : 4;
    let finishedTasks = 0;
    if (functionType === 'MAKEUP') {
      addSkuLookTourViewed && finishedTasks++;
      productGroupTourViewed && finishedTasks++;
      moduleConfigurationTourViewed && finishedTasks++;
      apiIntegrationTourViewed && finishedTasks++;
      analyticsTourViewed && finishedTasks++;
    } else if (functionType === 'EYEWEAR') {
      addEyewearFrameTourViewed && finishedTasks++;
      productEyewearTourViewed && finishedTasks++;
      lensTintEyewearTourViewed && finishedTasks++;
      moduleConfigurationTourEyewearViewed && finishedTasks++;
      apiIntegrationTourEyewearViewed && finishedTasks++;
      analyticsTourEyewearViewed && finishedTasks++;
    }

    const progress = (finishedTasks / totalTasks) * 100;

    return (
      <div className="tutorial-block">
        <Modal centered size="lg" show={isOpened} onShow={this.handleTourOpen}>
          <Modal.Body>
            <button
              className="btn btn-icon btn-lg tutorial_close"
              onClick={this.handleTourClose}
            >
              <i className="la la-remove" />
            </button>
            <div className="row tutorial_modal">
              <div className="col-6 tutorial_modal--left">
                <div>
                  <div className="tutorial_modal--left-top">
                    {progress === 100 ? (
                      <div className="tutorial_title">
                        <div className="tutorial_title--bold">
                          <Trans i18nKey="c.tutorial.title.complete.tour.title">
                            Congratulations!
                          </Trans>
                        </div>
                        <Trans i18nKey="c.tutorial.title.complete.tour.desc">
                          You've completed the tutorial.
                        </Trans>
                      </div>
                    ) : (
                      <div className="tutorial_title">
                        {functionType === 'MAKEUP' ? (
                          <Trans i18nKey="c.tutorial.title.start.tour.makeup">
                            Start Your Tour of
                            <div className="tutorial_title--bold">
                              Makeup Online Service
                            </div>
                          </Trans>
                        ) : (
                          <Trans i18nKey="c.tutorial.title.start.tour.eyewear">
                            Start Your Tour of
                            <div className="tutorial_title--bold">
                              Eyewear Online Service
                            </div>
                          </Trans>
                        )}
                      </div>
                    )}
                    <div className="tutorial_progress">
                      <div className="tutorial_progress-text">
                        <Trans i18nKey="c.tutorial.task.progress">
                          {{finishedTasks}}/{{totalTasks}} tasks complete
                        </Trans>
                      </div>
                      <div className="tutorial_progress-bar">
                        <div
                          className="tutorial_progress-bar--solid"
                          style={{width: `${progress}%`}}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="tutorial_video">
                    {functionType === 'MAKEUP' ? (
                      <VideoPlayer
                        videoUrl={
                          i18n.language === 'ja'
                            ? 'https://plugins-media.makeupar.com/pfweb/videos/Online service_JP.mp4'
                            : 'https://plugins-media.makeupar.com/pfweb/videos/Online Service Tutorial_EP1_ENG.mp4'
                        }
                        videoCover={
                          i18n.language === 'ja'
                            ? require('../../assets/images/tutorial/Online_Service_JP.png')
                            : require('../../assets/images/tutorial/Online_Service.png')
                        }
                      />
                    ) : (
                      <VideoPlayer
                        videoUrl={
                          'https://plugins-media.makeupar.com/pfweb/videos/Eyewear_online%20services_EP1-2.mp4'
                        }
                        videoCover={require('../../assets/images/tutorial/Eyewear_onlineServices_EP1_Cover.jpg')}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="col-6">
                <div className="tutorial_tasks">
                  {functionType === 'MAKEUP' && (
                    <div>
                      <div
                        className="row tutorial_task tutorial_task--first"
                        onClick={() => {
                          gtmUtils.sendEvent('gtm_start_sku');
                          this.handleTaskClick('/products/list-skus');
                        }}
                      >
                        <div className="col-3 tutorial_task_img">
                          <img
                            alt="icon"
                            className="tutorial_task_img_icon"
                            src={
                              addSkuLookTourViewed
                                ? require('../../assets/images/tutorial/icon_adding_gray.png')
                                : require('../../assets/images/tutorial/icon_adding.png')
                            }
                            style={{maxWidth: '47px'}}
                          />
                          {addSkuLookTourViewed && (
                            <img
                              alt="icon"
                              className="tutorial_task_img_finished"
                              src={require('../../assets/images/tutorial/finished.png')}
                            />
                          )}
                        </div>
                        <div className="col-9">
                          <div className="tutorial_task-title">
                            <Trans i18nKey="c.tutorial.task.add.skus.looks.title">
                              SKUs Creation
                            </Trans>
                          </div>
                          <div className="tutorial_task-description">
                            <Trans i18nKey="c.tutorial.task.add.skus.looks.desc">
                              Manage yours SKUs enable them for your web module.
                            </Trans>
                          </div>
                          <div className="tutorial_task-steps">
                            {this.getTaskStepCount(
                              tutorials.steps.addSkuLookTour.length
                            )}
                          </div>
                        </div>
                      </div>
                      {isUpgrade && (
                        <div
                          className="row tutorial_task"
                          onClick={() => {
                            gtmUtils.sendEvent('gtm_start_product');
                            this.handleTaskClick('/products/list-products');
                          }}
                        >
                          {/*<div className="guide-new-ribbon">new</div>*/}
                          <div className="col-3 tutorial_task_img">
                            <img
                              alt="icon"
                              className="tutorial_task_img_icon"
                              src={
                                productGroupTourViewed
                                  ? require('../../assets/images/tutorial/icon_group_gray.png')
                                  : require('../../assets/images/tutorial/icon_group.png')
                              }
                              style={{maxWidth: '47px'}}
                            />
                            {productGroupTourViewed && (
                              <img
                                alt="icon"
                                className="tutorial_task_img_finished"
                                src={require('../../assets/images/tutorial/finished.png')}
                              />
                            )}
                          </div>
                          <div className="col-9">
                            <div className="tutorial_task-title">
                              <Trans i18nKey="c.tutorial.task.product.grouping.title">
                                Product Grouping
                              </Trans>
                            </div>
                            <div className="tutorial_task-description">
                              <Trans i18nKey="c.tutorial.task.product.grouping.desc">
                                Create a product and group your SKUs, then try
                                Floating Widget mode to show your product
                                listing.
                              </Trans>
                            </div>
                            <div className="tutorial_task-steps">
                              {this.getTaskStepCount(
                                tutorials.steps.productGroupingTour.length
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      <div
                        className="row tutorial_task"
                        onClick={() => {
                          gtmUtils.sendEvent('gtm_start_module');
                          this.handleTaskClick('/web-module/configuration');
                        }}
                      >
                        <div className="col-3 tutorial_task_img">
                          <img
                            alt="icon"
                            className="tutorial_task_img_icon"
                            src={
                              moduleConfigurationTourViewed
                                ? require('../../assets/images/tutorial/icon_setting_gray.png')
                                : require('../../assets/images/tutorial/icon_setting.png')
                            }
                            style={{maxWidth: '59px'}}
                          />
                          {moduleConfigurationTourViewed && (
                            <img
                              alt="icon"
                              className="tutorial_task_img_finished"
                              src={require('../../assets/images/tutorial/finished.png')}
                            />
                          )}
                        </div>
                        <div className="col-9">
                          <div className="tutorial_task-title">
                            <Trans i18nKey="c.tutorial.task.module.configuration.title">
                              Module Configuration
                            </Trans>
                          </div>
                          <div className="tutorial_task-description">
                            <Trans i18nKey="c.tutorial.task.module.configuration.desc">
                              c.tutorial.task.module.configuration.desc
                            </Trans>
                          </div>
                          <div className="tutorial_task-steps">
                            {this.getTaskStepCount(
                              tutorials.steps.moduleConfigurationTour.length
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className="row tutorial_task"
                        onClick={() => {
                          gtmUtils.sendEvent('gtm_start_api');
                          this.handleTaskClick('/web-module/api-document');
                        }}
                      >
                        {/*{isUpgrade && <div className="guide-new-ribbon">new</div>}*/}
                        <div className="col-3 tutorial_task_img">
                          <img
                            alt="icon"
                            className="tutorial_task_img_icon"
                            src={
                              apiIntegrationTourViewed
                                ? require('../../assets/images/tutorial/icon_api_gray.png')
                                : require('../../assets/images/tutorial/icon_api.png')
                            }
                            style={{maxWidth: '61px'}}
                          />
                          {apiIntegrationTourViewed && (
                            <img
                              alt="icon"
                              className="tutorial_task_img_finished"
                              src={require('../../assets/images/tutorial/finished.png')}
                            />
                          )}
                        </div>
                        <div className="col-9">
                          <div className="tutorial_task-title">
                            <Trans i18nKey="c.tutorial.task.api.integration.title">
                              API Integration
                            </Trans>
                          </div>
                          <div className="tutorial_task-description">
                            <Trans i18nKey="c.tutorial.task.api.integration.desc">
                              Get the API key and snippet. For more help on
                              this, please refer to the 'Sample Code and API'
                              documentation.
                            </Trans>
                          </div>
                          <div className="tutorial_task-steps">
                            {this.getTaskStepCount(
                              tutorials.steps.apiIntegrationTour.length
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className="row tutorial_task"
                        onClick={() => {
                          gtmUtils.sendEvent('gtm_start_analytics');
                          this.handleTaskClick('/web-module/reports/overview');
                        }}
                      >
                        <div className="col-3 tutorial_task_img">
                          <img
                            alt="icon"
                            className="tutorial_task_img_icon"
                            src={
                              analyticsTourViewed
                                ? require('../../assets/images/tutorial/icon_analytics_gray.png')
                                : require('../../assets/images/tutorial/icon_analytics.png')
                            }
                            style={{maxWidth: '59px'}}
                          />
                          {analyticsTourViewed && (
                            <img
                              alt="icon"
                              className="tutorial_task_img_finished"
                              src={require('../../assets/images/tutorial/finished.png')}
                            />
                          )}
                        </div>
                        <div className="col-9">
                          <div className="tutorial_task-title">
                            <Trans i18nKey="c.tutorial.task.analytics.title">
                              Analytics
                            </Trans>
                          </div>
                          <div className="tutorial_task-description">
                            <Trans i18nKey="c.tutorial.task.analytics.desc">
                              Gain actionable insight into the impact that
                              virtual try-on has on your customers’ shopping
                              journeys.
                            </Trans>
                          </div>
                          <div className="tutorial_task-steps">
                            {this.getTaskStepCount(
                              tutorials.steps.analyticsTour.length
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {functionType === 'EYEWEAR' && (
                    <div>
                      <div
                        className="row tutorial_task"
                        onClick={() => {
                          gtmUtils.sendEvent('gtm_start_sku');
                          this.handleTaskClick(
                            '/eyewear/list-products?mode=eyewear-product'
                          );
                        }}
                      >
                        <div className="col-3 tutorial_task_img">
                          <img
                            alt="icon"
                            className="tutorial_task_img_icon"
                            src={
                              productEyewearTourViewed
                                ? require('../../assets/images/tutorial/icon_group_gray.png')
                                : require('../../assets/images/tutorial/icon_group.png')
                            }
                            style={{maxWidth: '47px'}}
                          />
                          {productEyewearTourViewed && (
                            <img
                              alt="icon"
                              className="tutorial_task_img_finished"
                              src={require('../../assets/images/tutorial/finished.png')}
                            />
                          )}
                        </div>
                        <div className="col-9">
                          <div className="tutorial_task-title">
                            <Trans i18nKey="c.tutorial.task.add.eyewear.product.title">
                              Create a Eyewear Product
                            </Trans>
                          </div>
                          <div className="tutorial_task-description">
                            <Trans i18nKey="c.tutorial.task.add.eyewear.product.desc">
                              Manage all your digital products, and publish them
                              to your web module.
                            </Trans>
                          </div>
                          <div className="tutorial_task-steps">
                            {this.getTaskStepCount(
                              tutorials.steps.addEyewearProductTour.length
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className="row tutorial_task"
                        onClick={() => {
                          gtmUtils.sendEvent('gtm_start_frame');
                          this.handleTaskClick(
                            '/eyewear/list-products?mode=eyewear-frame'
                          );
                        }}
                      >
                        {/*<div className="guide-new-ribbon">new</div>*/}
                        <div className="col-3 tutorial_task_img">
                          <img
                            alt="icon"
                            className="tutorial_task_img_icon"
                            src={
                              addEyewearFrameTourViewed
                                ? require('../../assets/images/tutorial/icon_frame_adding_gray.png')
                                : require('../../assets/images/tutorial/icon_frame_adding.png')
                            }
                            style={{maxWidth: '47px'}}
                          />
                          {addEyewearFrameTourViewed && (
                            <img
                              alt="icon"
                              className="tutorial_task_img_finished"
                              src={require('../../assets/images/tutorial/finished.png')}
                            />
                          )}
                        </div>
                        <div className="col-9">
                          <div className="tutorial_task-title">
                            <Trans i18nKey="c.tutorial.task.eyewear.create.frame.title">
                              Create a New Frame
                            </Trans>
                          </div>
                          <div className="tutorial_task-description">
                            <Trans i18nKey="c.tutorial.task.eyewear.create.frame.desc">
                              Upload Frame images to try virtual try on effect.
                            </Trans>
                          </div>
                          <div className="tutorial_task-steps">
                            {this.getTaskStepCount(
                              tutorials.steps.productGroupingTour.length
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className="row tutorial_task"
                        onClick={() => {
                          gtmUtils.sendEvent('gtm_start_lens');
                          this.handleTaskClick(
                            '/eyewear/list-products?mode=eyewear-lenstint'
                          );
                        }}
                      >
                        <div className="col-3 tutorial_task_img">
                          <img
                            alt="icon"
                            className="tutorial_task_img_icon"
                            src={
                              lensTintEyewearTourViewed
                                ? require('../../assets/images/tutorial/icon_lens_adding_gray.png')
                                : require('../../assets/images/tutorial/icon_lens_adding.png')
                            }
                            style={{maxWidth: '47px'}}
                          />
                          {lensTintEyewearTourViewed && (
                            <img
                              alt="icon"
                              className="tutorial_task_img_finished"
                              src={require('../../assets/images/tutorial/finished.png')}
                            />
                          )}
                        </div>
                        <div className="col-9">
                          <div className="tutorial_task-title">
                            <Trans i18nKey="c.tutorial.task.add.eyewear.lens.tint.title">
                              Select Lens Tint and Frame Size
                            </Trans>
                          </div>
                          <div className="tutorial_task-description">
                            <Trans i18nKey="c.tutorial.task.add.eyewear.lens.tint.desc">
                              Assign different lens tints and frame sizes to
                              your digital frame.
                            </Trans>
                          </div>
                          <div className="tutorial_task-steps">
                            {this.getTaskStepCount(
                              tutorials.steps.addEyewearLensTintTour.length
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className="row tutorial_task"
                        onClick={() => {
                          gtmUtils.sendEvent('gtm_start_module');
                          this.handleTaskClick('/web-module/configuration');
                        }}
                      >
                        <div className="col-3 tutorial_task_img">
                          <img
                            alt="icon"
                            className="tutorial_task_img_icon"
                            src={
                              moduleConfigurationTourEyewearViewed
                                ? require('../../assets/images/tutorial/icon_setting_gray.png')
                                : require('../../assets/images/tutorial/icon_setting.png')
                            }
                            style={{maxWidth: '59px'}}
                          />
                          {moduleConfigurationTourEyewearViewed && (
                            <img
                              alt="icon"
                              className="tutorial_task_img_finished"
                              src={require('../../assets/images/tutorial/finished.png')}
                            />
                          )}
                        </div>
                        <div className="col-9">
                          <div className="tutorial_task-title">
                            <Trans i18nKey="c.tutorial.task.module.configuration.title">
                              Module Configuration
                            </Trans>
                          </div>
                          <div className="tutorial_task-description">
                            <Trans i18nKey="c.tutorial.task.module.configuration.desc">
                              Set all the remaining options.
                            </Trans>
                          </div>
                          <div className="tutorial_task-steps">
                            {this.getTaskStepCount(
                              tutorials.steps.moduleConfigurationTour.length
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className="row tutorial_task"
                        onClick={() => {
                          gtmUtils.sendEvent('gtm_start_api');
                          this.handleTaskClick('/web-module/api-document');
                        }}
                      >
                        {/*{isUpgrade && <div className="guide-new-ribbon">new</div>}*/}
                        <div className="col-3 tutorial_task_img">
                          <img
                            alt="icon"
                            className="tutorial_task_img_icon"
                            src={
                              apiIntegrationTourEyewearViewed
                                ? require('../../assets/images/tutorial/icon_api_gray.png')
                                : require('../../assets/images/tutorial/icon_api.png')
                            }
                            style={{maxWidth: '61px'}}
                          />
                          {apiIntegrationTourEyewearViewed && (
                            <img
                              alt="icon"
                              className="tutorial_task_img_finished"
                              src={require('../../assets/images/tutorial/finished.png')}
                            />
                          )}
                        </div>
                        <div className="col-9">
                          <div className="tutorial_task-title">
                            <Trans i18nKey="c.tutorial.task.api.integration.title">
                              API Integration
                            </Trans>
                          </div>
                          <div className="tutorial_task-description">
                            <Trans i18nKey="c.tutorial.task.api.integration.desc">
                              Get the API key and snippet. For more help on
                              this, please refer to the 'Sample Code and API'
                              documentation.
                            </Trans>
                          </div>
                          <div className="tutorial_task-steps">
                            {this.getTaskStepCount(
                              tutorials.steps.apiIntegrationTour.length
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className="row tutorial_task"
                        onClick={() => {
                          gtmUtils.sendEvent('gtm_start_analytics');
                          this.handleTaskClick('/web-module/reports/overview');
                        }}
                      >
                        <div className="col-3 tutorial_task_img">
                          <img
                            alt="icon"
                            className="tutorial_task_img_icon"
                            src={
                              analyticsTourEyewearViewed
                                ? require('../../assets/images/tutorial/icon_analytics_gray.png')
                                : require('../../assets/images/tutorial/icon_analytics.png')
                            }
                            style={{maxWidth: '59px'}}
                          />
                          {analyticsTourEyewearViewed && (
                            <img
                              alt="icon"
                              className="tutorial_task_img_finished"
                              src={require('../../assets/images/tutorial/finished.png')}
                            />
                          )}
                        </div>
                        <div className="col-9">
                          <div className="tutorial_task-title">
                            <Trans i18nKey="c.tutorial.task.analytics.title">
                              Analytics
                            </Trans>
                          </div>
                          <div className="tutorial_task-description">
                            <Trans i18nKey="c.tutorial.task.analytics.desc">
                              Gain actionable insight into the impact that
                              virtual try-on has on your customers’ shopping
                              journeys.
                            </Trans>
                          </div>
                          <div className="tutorial_task-steps">
                            {this.getTaskStepCount(
                              tutorials.steps.analyticsTour.length
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
